export const SCHOOLCODE_USERGUIDE_NAME = 'SchoolCodeRequestPortalUserGuide';
export const SCORESENDCODE_USERGUIDE_NAME = 'ScoreSendCodeRequestPortalUserGuide';